import React, { useState, useEffect, Fragment, useRef } from 'react';
import { Outlet } from 'react-router';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import Header from './components/Header';
import LoadingSpinner from '@Components/LoadingSpinner';
import { useCancelPromise } from "@Utilities/services/hooks";
import { LocalizationContext, getLocalizedCopy } from '@local/services/localization';
import './styles/coreLayout.scss';

export default function CoreLayout({
  locale,
  params,
  loadLocale,
  loadSettings
}) {
  const bodyRef = useRef();
  const cancelPromise = useCancelPromise();
  const [isSettingsLoading, setIsSettingsLoading] = useState(true);

  const updateLocale = (locale = '') => {
    if (locale === 'fr' || locale === 'fr-CA') {
      loadLocale('fr-CA');
    } else {
      const locale = sessionStorage.getItem('locale');
      if (locale) loadLocale(locale);
    }
  };

  useEffect(() => {
    const { locale = '' } = params || {};
    updateLocale(locale);

    const sessionId = sessionStorage.getItem('sessionId');
    if (!sessionId) sessionStorage.setItem('sessionId', uuidv4());

    loadSettings()
      .then(() => {
        if (!cancelPromise.current) {
          setIsSettingsLoading(false);
        }
      });
  }, []);

  return (
    <LocalizationContext.Provider value={getLocalizedCopy(locale)}>
      <div ref={bodyRef} className="core-layout" >
        {isSettingsLoading ? (
          <LoadingSpinner className="core-layout__loading-spinner" />
        ) : (
          <Fragment>
            <Header />
            <Outlet />
          </Fragment>
        )}
      </div>
    </LocalizationContext.Provider>
  );
}

CoreLayout.propTypes = {
  locale: PropTypes.string,
  loadLocale: PropTypes.func,
  params: PropTypes.object,
  loadSettings: PropTypes.func
};
